<script setup lang="ts">

const customerStore = useCustomerStore();
const { signedIn } = storeToRefs(customerStore);
</script>
<template>
    <!--    CUSTOM IDS-61: changed styling-->
    <div v-if="!signedIn" class="flex gap-3 py-4 md:justify-end">
        <CountrySwitch />
    </div>
</template>
